<div class="container-fluid component-defauts">
    <div class="component-title mb-3">ESTATÍSTICAS</div>

    <div class="date-label">{{currentDateLabel}}</div>
    
    <div class="chart-wrapper my-5">
        <canvas baseChart [data]="pieChartData" [labels]="pieChartLabels" [colors]="pieChartColors" [chartType]="pieChartType"
            [options]="pieChartOptions" [plugins]="pieChartPlugins" [legend]="pieChartLegend">
        </canvas>
    </div>

    <div class="container-fluid" *ngFor="let item of produtosUso">
        <div class="row item-row">
            <div class="col-8 px-0 item-name"><div class="dot" [style.background-color]="item.corHex"></div><span class="mx-3">{{item.produtoDescricao}}</span></div>
            <div class="col-4 px-0 item-values">{{item.valorGasto | currency:'BRL':true}} <br> {{item.porcentagemGasto}}% do saldo</div>
        </div>
    </div>
</div>